<!--table starts-->
<section id="ng-tables">
    <div class="row text-left">
      <div class="col-12">
        <div class="content-header">Apps</div>
      </div>
    </div>
    <div class="row text-left">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <form>
                <div class="form-group form-inline">
                  Full text search: <input class="form-control ml-2" type="text" name="searchTerm"/>
                </div>
  
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" sortable="title" (sort)="onSort($event)">Title</th>
                        <th scope="col" sortable="type" (sort)="onSort($event)">Type</th>
                        <th scope="col" >Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let topic of topicContents$ | async">
                        <th scope="row">{{ country.id }}</th>
                        <td>
                          <ngb-highlight [result]="topic.id" [term]="service.searchTerm"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="topic.title" [term]="service.searchTerm"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="country.type" [term]="service.searchTerm"></ngb-highlight>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <!-- <div class="d-flex justify-content-between p-2">
                  <ngb-pagination [collectionSize]="total$ | async" [(page)]="service.page" [pageSize]="service.pageSize">
                  </ngb-pagination>
  
                  <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
                    <option [ngValue]="2">2 items per page</option>
                    <option [ngValue]="4">4 items per page</option>
                    <option [ngValue]="6">6 items per page</option>
                  </select>
                </div> -->
  
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--table ends-->
  